import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useFieldArray, useForm } from 'react-hook-form'
import ProdutoService from 'business/cadastro/produto/produto/produtoService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'
import UnidadeService from 'business/cadastro/produto/unidade/unidadeService'
import OrigemProdutoService from 'business/cadastro/produto/origemProduto/origemProdutoService'
import MarcaService from 'business/cadastro/produto/marca/marcaService'
import AutenticidadeService from 'business/cadastro/produto/autenticidade/autenticidadeService'
import TipoProdutoService from 'business/cadastro/produto/tipoProduto/tipoProdutoService'
import CorService from 'business/cadastro/produto/cor/corService'
import TamanhoService from 'business/cadastro/produto/tamanho/tamanhoService'
import CondicaoProdutoService from 'business/cadastro/produto/condicaoProduto/condicaoProdutoService'
import { createCodeDescriptionObject, formatDatetime } from 'helper/formater'
import EnderecoProdutoService from 'business/cadastro/produto/enderecoProduto/enderecoProdutoService'
import queryString from 'query-string'
import EnderecoProdutoAutoComplete from 'business/cadastro/produto/enderecoProduto/components/EnderecoProdutoAutoComplete'
import { Button } from 'primereact/button'
import PessoaService from 'business/cadastro/pessoa/pessoa/pessoaService'
import { confirmDialog } from 'primereact/confirmdialog'
import { Divider } from 'primereact/divider'
import OutputSpanForm from 'base/OutputSpanForm'
import { getCustomPresignedPost } from 'helper/bucket'
import axios from 'axios'
import { Image } from 'primereact/image'
import * as auth from "infra/localStorage.js"
import { v4 as uuidv4 } from 'uuid'
import { convertImageToWebP, generateThumbnailBlob, getImageInfo } from 'helper/image'

export default function Produto() {

    const [service] = useState(() => new ProdutoService())

    const [unidades, setUnidades] = useState([])
    const [origemProdutos, setOrigemProdutos] = useState([])
    const [marcas, setMarcas] = useState([])
    const [autenticidades, setAutenticidades] = useState([])
    const [tipoProdutos, setTipoProdutos] = useState([])
    const [cors, setCors] = useState([])
    const [tamanhos, setTamanhos] = useState([])
    const [condicaoProdutos, setCondicaoProdutos] = useState([])
    const [enderecos, setEnderecos] = useState([])
    const [enderecoSelecionados, setEnderecoSelecionados] = useState([])
    const [fornecedores, setFornecedores] = useState([])
    const [registro, setRegistro] = useState({})
    const inputImageRef = useRef(null)
    const [inputKey, setInputKey] = useState(Date.now())
    const navigate = useNavigate()
    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load({}),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    const produtoEndereco = useFieldArray({
        control: form.control,
        name: "produto_endereco"
    })
    const produtoFornecedor = useFieldArray({
        control: form.control,
        name: "produto_fornecedor"
    })
    const arquivo = useFieldArray({
        control: form.control,
        name: "arquivo"
    })

    async function load({ dataId }) {

        const data = await FormCadastroAux.load({ id: id || dataId, service, toast, beforeSubmit, useNew: true })

        if (data?.unidade) {
            const unids = []
            unids.push(createCodeDescriptionObject(data.unidade, 'codigo_unid', 'sigla_unid', false))

            data.produto_fornecedor.map(e => {
                if (e.unidade?.codigo_unid)
                    unids.push(createCodeDescriptionObject(e.unidade, 'codigo_unid', 'sigla_unid', false))
            })
            unids.push({ codigo_unid: null, sigla_unid: defaultEmptySelection() })
            setUnidades(unids)
        }
        if (data?.origem_produto) {
            const orip = [createCodeDescriptionObject(data.origem_produto, 'codigo_orip', 'descricao_orip', true)]
            setOrigemProdutos(orip)
        }
        if (data?.marca) {
            setMarcas([createCodeDescriptionObject(data.marca, 'codigo_marc', 'descricao_marc', false)])
        }
        if (data?.autenticidade) {
            setAutenticidades([createCodeDescriptionObject(data.autenticidade, 'codigo_aute', 'descricao_aute', false)])
        }
        if (data?.tipo_produto) {
            setTipoProdutos([createCodeDescriptionObject(data.tipo_produto, 'codigo_tipp', 'descricao_tipp', true)])
        }
        if (data?.cor) {
            setCors([createCodeDescriptionObject(data.cor, 'codigo_cor', 'descricao_cor', false)])
        }
        if (data?.tamanho) {
            setTamanhos([createCodeDescriptionObject(data.tamanho, 'codigo_tam', 'descricao_tam', false)])
        }
        if (data?.condicao_produto) {
            setCondicaoProdutos([createCodeDescriptionObject(data.condicao_produto, 'codigo_conp', 'descricao_conp', false)])
        }
        if (data?.produto_endereco) {
            const enderecosExistentes = data?.produto_endereco?.map((p) => ({ ...p.endereco_produto })) || []
            if (enderecosExistentes?.length > 0) enderecosExistentes[0].principal = true
            setEnderecoSelecionados(enderecosExistentes)
        }

        if (data?.produto_fornecedor) {
            const forns = data.produto_fornecedor.map(e => service.fornecedorToView({ pessoa: e.pessoa }))
            setFornecedores(forns)
            data.produto_fornecedor.forEach(e => e.cod_forn_pfor = e.pessoa)
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)

        service.formatActionOfArray(submitData.produto_fornecedor, form.formState.dirtyFields.produto_fornecedor)

        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadUnidades = async () => {
        const unid = new UnidadeService()
        await unid.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_unid', 'sigla_unid', false))
            options.push({ codigo_unid: null, sigla_unid: defaultEmptySelection() })
            setUnidades(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadOrigemProdutos = async () => {
        const orip = new OrigemProdutoService()
        await orip.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_orip', 'descricao_orip', true))
            options.push({ codigo_orip: null, descricao_orip: defaultEmptySelection() })
            setOrigemProdutos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadMarcas = async () => {
        const marc = new MarcaService()
        await marc.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_marc', 'descricao_marc', false))
            options.push({ codigo_marc: null, descricao_marc: defaultEmptySelection() })
            setMarcas(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadAutenticidades = async () => {
        const aute = new AutenticidadeService()
        await aute.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_aute', 'descricao_aute', false))
            options.push({ codigo_aute: null, descricao_aute: defaultEmptySelection() })
            setAutenticidades(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoProdutos = async () => {
        const tipp = new TipoProdutoService()
        await tipp.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tipp', 'descricao_tipp', true))
            options.push({ codigo_tipp: null, descricao_tipp: defaultEmptySelection() })
            setTipoProdutos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadCors = async () => {
        const cor = new CorService()
        await cor.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_cor', 'descricao_cor', false))
            options.push({ codigo_cor: null, descricao_cor: defaultEmptySelection() })
            setCors(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTamanhos = async () => {
        const tam = new TamanhoService()
        await tam.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tam', 'descricao_tam', false))
            options.push({ codigo_tam: null, descricao_tam: defaultEmptySelection() })
            setTamanhos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadCondicaoProdutos = async () => {
        const conp = new CondicaoProdutoService()
        await conp.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_conp', 'descricao_conp', false))
            options.push({ codigo_conp: null, descricao_conp: defaultEmptySelection() })
            setCondicaoProdutos(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    const loadEnderecos = async (event) => {

        if (!event.query) return

        const objQs = { page: 1, perPage: 6 }
        const splited = event.query.split(' ')

        if (splited) {
            if (splited.length > 0) objQs['setor_endp'] = splited[0].trim()
            if (splited.length > 1) objQs['rua_endp'] = splited[1].trim()
            if (splited.length > 2) objQs['bloco_endp'] = splited[2].trim()
            if (splited.length > 3) objQs['andar_endp'] = splited[3].trim()
        }

        const qs = queryString.stringify(objQs)
        const endp = new EnderecoProdutoService()
        await endp.list('?' + qs).then(rs => setEnderecos(rs.data.data)).catch(err => errorToToast({ err, toast }))
    }

    const enderecoFormatado = (e) => `${e.setor_endp} ${e.rua_endp} ${e.bloco_endp} ${e.andar_endp}`

    /**
     * Fornecedores
     */

    const loadFornecedores = async (event) => {

        event.query = (event?.query ?? '').trim()

        if (!event.query) return

        const serv = new PessoaService()
        await serv.listByAutoComplete(event.query).then(rs => setFornecedores(
            rs.data.data.map(e => service.fornecedorToView({ pessoa: e }))
        )).catch(err => errorToToast({ err, toast }))

    }

    // ATUALIZA O FORMULÁRIO
    const reloadForm = async ({ dataId, navigate }) => {

        navigate(`${service.frontUrl}/${dataId}`, { replace: true })
        form.reset(await load({ dataId }))

    }

    const handleImageChange = async (event) => {

        const originalFile = event.target.files[0]

        if (originalFile) {

            const isValid = await form.trigger()
            if (!isValid) return

            let convetidoFile = originalFile

            const originalFileInfo = await getImageInfo(originalFile)

            if (originalFileInfo.width > 1000 || originalFileInfo.height > 1000) {
                convetidoFile = await generateThumbnailBlob(originalFile, 1000, 1000, false, 0.8, 'image/webp')
            } else {
                convetidoFile = await convertImageToWebP(originalFile, 0.8)
            }

            const file = convetidoFile.size < originalFile.size ? convetidoFile : originalFile
            const thumbnail = await generateThumbnailBlob(originalFile, 96, 96, false, 0.8, 'image/webp')
            const appendedIndex = arquivo.fields.length
            const grupo = uuidv4().slice(0, 10)

            arquivo.append({
                cod_siarq_arq: 1, // 1-Aguardando um presignedPost
                cod_tiarq_arq: 1, // 1-Foto
                nome_original_arq: file.name,
                tamanho_bytes_arq: file.size,
                mime_type_arq: file.type,
                id_grupo_arq: grupo,
                action: 'ins',
            })
            arquivo.append({
                cod_siarq_arq: 1, // 1-Aguardando um presignedPost
                cod_tiarq_arq: 2, // 2-Foto (thumbnail)
                nome_original_arq: thumbnail.name,
                tamanho_bytes_arq: thumbnail.size,
                mime_type_arq: thumbnail.type,
                id_grupo_arq: grupo,
                action: 'ins',
            })

            const dataCopy = service.prepareToSave({ data: structuredClone(form.getValues()) })

            service.save(id, dataCopy).then(async (response) => {

                if (!response.data.meta || !response.data.meta.arquivo[appendedIndex].presignedPost) {
                    await reloadForm({ dataId: response.data.codigo_prod || id, navigate })
                    throw new Error('Não foi possível assinar o upload do arquivo')
                }

                for (const elem of response.data.meta.arquivo) {

                    if (!elem.presignedPost) continue

                    const post = getCustomPresignedPost({
                        presignedPost: elem.presignedPost,
                        binaryFile: elem.cod_tiarq_arq === 1 ? file : thumbnail
                    })

                    try {
                        // Faz o upload para o S3
                        const s3Response = await axios.post(post.url, post.formData, { headers: post.headers })
                            .catch(err => {
                                console.error('S3 err: ', err)
                            })

                        if (s3Response.status !== 204) {
                            console.error('s3Response: ', s3Response)
                            throw new Error(`Erro no upload: ${JSON.stringify(s3Response.data || s3Response.statusText || s3Response)}`)
                        }

                    } catch (error) {
                        await reloadForm({ dataId: response.data.codigo_prod || id, navigate })
                        throw new Error(`Erro no upload: ${error}`)
                    }

                }

                await reloadForm({ dataId: response.data.codigo_prod || id, navigate })

            }).catch(async (err) => {
                await reloadForm({ dataId: id, navigate })
                FormCadastroAux.showExceptions(err)
            })
        }

        setInputKey(Date.now())

    }

    const getImgUrlOriginal = (idGrupoArq) => {
        return arquivo.fields.find((item) => item.id_grupo_arq === idGrupoArq && item.cod_tiarq_arq === 1)?.nome_armazenado_arq
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit} >

            <GridForm>
                <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="descricao_prod" form={form} service={service} type="text" clearString label="Descrição" />
            </GridForm>
            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}
                onBeforeTabChange={async (e) => {
                    if (e.index === 8) {
                        if (!registro?.meta) {
                            const rs = await service.getById({ id, includes: 'registro' })
                            if (rs?.data?.meta?.registro)
                                setRegistro(rs.data.meta.registro)
                        }

                    }

                }}
            >

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="referencia_prod" form={form} service={service} type="text" clearString label="Referência" placeholder="Automático" />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="ncm_prod" form={form} service={service} type="text" inputMode="numeric" clearString label="NCM" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cest_prod" form={form} service={service} type="text" inputMode="numeric" clearString label="CEST" />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_orip_prod" form={form} type="dropdown2" service={service} label="Origem"
                            optionKey='codigo_orip'
                            optionLabel='descricao_orip'
                            options={origemProdutos}
                            onLoad={loadOrigemProdutos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tipp_prod" form={form} type="dropdown2" service={service} label="Tipo de produto"
                            optionKey='codigo_tipp'
                            optionLabel='descricao_tipp'
                            options={tipoProdutos}
                            onLoad={loadTipoProdutos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_unid_prod" form={form} type="dropdown2" service={service} label="Unidade"
                            optionKey='codigo_unid'
                            optionLabel='sigla_unid'
                            options={unidades}
                            onLoad={loadUnidades}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_marc_prod" form={form} type="dropdown2" service={service} label="Marca"
                            optionKey='codigo_marc'
                            optionLabel='descricao_marc'
                            options={marcas}
                            onLoad={loadMarcas}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_ean_prod" form={form} service={service} type="text" inputMode="numeric" clearString label="Código EAN" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_barra_prod" form={form} service={service} type="text" inputMode="numeric" clearString label="Código de barras" placeholder="Automático" />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_aute_prod" form={form} type="dropdown2" service={service} label="Autenticidade"
                            optionKey='codigo_aute'
                            optionLabel='descricao_aute'
                            options={autenticidades}
                            onLoad={loadAutenticidades}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_conp_prod" form={form} type="dropdown2" service={service} label="Condição do produto"
                            optionKey='codigo_conp'
                            optionLabel='descricao_conp'
                            options={condicaoProdutos}
                            onLoad={loadCondicaoProdutos}
                        />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="ativo_prod" form={form} service={service} type="switch" label="Ativo" />

                        <div className='field col-12 mb-2 col-12 md:col-6 lg:col-8 xl:col-6'>
                            <EnderecoProdutoAutoComplete
                                inputId={'produtoEndereco'}
                                label='Endereço (1º principal)'
                                selecionados={enderecoSelecionados}
                                setSelecionados={e => {
                                    if (e.length > 0) e[0].principal = true
                                    setEnderecoSelecionados(e)
                                }}
                                filtrados={enderecos}
                                carregarEnderecos={loadEnderecos}
                                enderecoFormatado={enderecoFormatado}
                                form={form}
                                controller={{ field: { name: 'produto_endereco' } }}
                                beforeInsert={inserted => {
                                    const novo = {
                                        codigo_proe: null,
                                        cod_prod_proe: form.getValues('codigo_prod'),
                                        cod_endp_proe: inserted.codigo_endp,
                                        principal_proe: 0,
                                        dh_atua_proe: null,
                                        endereco_produto: {},
                                        meta: {},
                                        action: 'ins'
                                    }
                                    produtoEndereco.append(novo)
                                    return true
                                }}
                                beforeDelete={endp => {
                                    const index = form.getValues('produto_endereco').findIndex(p => p.cod_endp_proe === endp.codigo_endp)
                                    const elem = form.getValues('produto_endereco')[index]

                                    const produtoEnderecoRemoved = form.getValues('produtoEnderecoRemoved') || []
                                    produtoEnderecoRemoved.push(elem)

                                    form.setValue('produtoEnderecoRemoved', produtoEnderecoRemoved)

                                    if (index >= 0) {
                                        produtoEndereco.remove(index)
                                    }
                                    return true
                                }}
                                placeholder={form.getValues('produto_endereco')?.length > 0 ? 'Digite...' : 'Digite para pesquisar'}
                            />
                        </div>

                    </GridForm>

                </TabPanel>

                <TabPanel header="Características" leftIcon="pi pi-sparkles mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="peso_liquido_prod" form={form} service={service} type="number" label="Peso líquido" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="peso_bruto_prod" form={form} service={service} type="number" label="Peso bruto" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="vol_altura_prod" form={form} service={service} type="number" label="Altura" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="vol_comprimento_prod" form={form} service={service} type="number" label="Comprimento" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="vol_largura_prod" form={form} service={service} type="number" label="Largura" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_cor_prod" form={form} type="dropdown2" service={service} label="Cor"
                            optionKey='codigo_cor'
                            optionLabel='descricao_cor'
                            options={cors}
                            onLoad={loadCors}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tam_prod" form={form} type="dropdown2" service={service} label="Tamanho"
                            optionKey='codigo_tam'
                            optionLabel='descricao_tam'
                            options={tamanhos}
                            onLoad={loadTamanhos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="vida_util_meses_prod" form={form} service={service} type="number" label="Vida útil em meses" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="venc_prod" form={form} service={service} type="calendar" inputMode="numeric" label="Vencimento" />
                    </GridForm>
                </TabPanel>
                <TabPanel header="Fornecedores" leftIcon="pi pi-truck mr-2">
                    <GridForm>
                        {produtoFornecedor.fields.map((item, index) => {

                            return (
                                <div key={item.id} className='grid col-12 m-0 p-0'>
                                    <ControllerInput addClassName="md:col-4 lg:col-3 xl:col-2"
                                        form={form} service={service} type="autocomplete" label="Fornecedor"
                                        field={`produto_fornecedor[${index}].cod_forn_pfor`}
                                        suggestions={fornecedores}
                                        completeMethod={loadFornecedores}
                                        fieldShow={e => service.getFieldShowFornecedor({ data: e })}
                                        itemTemplate={(item) => <span>{service.getItemTemplateFornecedor({ pessoa: item })}</span>}
                                        placeholder='Nome, código ou CPF/CNPJ'
                                    />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`produto_fornecedor[${index}].ref_fabr_pfor`} form={form} service={service} type="text" clearString label="Referência de fábrica" />
                                    <ControllerInput addClassName="md:col-3 lg:col-2 xl:col-1" field={`produto_fornecedor[${index}].cod_unid_compra_pfor`} form={form} service={service} type="dropdown2" clearString label="Un. compra"
                                        optionKey='codigo_unid'
                                        optionLabel='sigla_unid'
                                        options={unidades}
                                        onLoad={loadUnidades}
                                    />

                                    <ControllerInput addClassName="md:col-2 lg:col-2 xl:col-2" field={`produto_fornecedor[${index}].fator_convs_pfor`} form={form} service={service} type="number" clearString label="Fator conversão" />
                                    <ControllerInput addClassName="md:col-4 lg:col-2 xl:col-2" field={`produto_fornecedor[${index}].valor_ult_compra_pfor`} form={form} service={service} type="number" clearString label="Valor úl. compra" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`produto_fornecedor[${index}].dh_ult_compra_pfor`} form={form} service={service} type="calendar" clearString label="Data úl. compra"
                                        showTime
                                        hourFormat="24"
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999 99:99"
                                    />

                                    <Button
                                        id="btnRmFornecedor"
                                        className="md:col-1 lg:col-1 xl:col-1"
                                        icon="pi pi-trash"
                                        size="small"
                                        onClick={(e) => {
                                            e.preventDefault()

                                            /**
                                             * item só tem valor do load inicial e não
                                             * precisa registrar removidos que não tem no item!
                                             */

                                            const atual = produtoFornecedor.fields[index]
                                            const nome = atual?.cod_forn_pfor?.nome_razao_pes || null

                                            const fnRemover = () => {
                                                const removeds = form.getValues(`produtoFornecedorRemoved`) || []
                                                if (item?.codigo_pfor) {
                                                    removeds.push({ codigo_pfor: item.codigo_pfor })
                                                    form.setValue('produtoFornecedorRemoved', removeds)
                                                }
                                                produtoFornecedor.remove(index, { shouldFocus: false })
                                            }

                                            if (nome) {
                                                confirmDialog({ message: 'Confirma remover? ' + nome, icon: 'pi pi-question-circle', accept: fnRemover })
                                            } else {
                                                fnRemover()
                                            }
                                        }}
                                        severity="warning"
                                        text
                                    />
                                    {produtoFornecedor.fields.length > 1 && <Divider className='flex mt-2 mb-2'></Divider>}

                                </div>
                            )
                        })}

                        <div className="flex m-2 justify-content-start">
                            <Button
                                id='btnAddFornecedor'
                                onClick={(e) => {
                                    e.preventDefault()
                                    produtoFornecedor.append(service.getNewProdutoFornecedor(), { shouldFocus: false })
                                }}
                            >Adicionar</Button>
                        </div>
                    </GridForm>

                </TabPanel>

                <TabPanel header="Estoque" leftIcon="pi pi-database mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.estoque_minimo_prem" form={form} service={service} type="number" label="Estoque mínimo" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.estoque_maximo_prem" form={form} service={service} type="number" label="Estoque máximo" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.qtd_minima_compra_prem" form={form} service={service} type="number" label="Qtd. mínima de compra" />
                        <Divider></Divider>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.estoque_atual_prem" form={form} service={service} type="number" label="Estoque atual" disabled />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.qtd_aplicada_prem" form={form} service={service} type="number" label="Qtd. aplicada" disabled />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.qtd_reservada_prem" form={form} service={service} type="number" label="Qtd. reservada" disabled />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.qtd_transito_prem" form={form} service={service} type="number" label="Qtd. trânsito" disabled />

                    </GridForm>
                </TabPanel>
                <TabPanel header="Preços" leftIcon="pi pi-dollar mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_varejo_prem" form={form} service={service} type="number" label="Varejo" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_atacado_prem" form={form} service={service} type="number" label="Atacado" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_ecommerce_prem" form={form} service={service} type="number" label="E-commerce" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_sugerido_prem" form={form} service={service} type="number" label="Sugerido" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_garantia_prem" form={form} service={service} type="number" label="Garantia" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_reposicao_prem" form={form} service={service} type="number" label="Reposição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_minimo_prem" form={form} service={service} type="number" label="Mínimo" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.preco_promocao_prem" form={form} service={service} type="number" label="Promoção" />
                        <Divider></Divider>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.custo_medio_bruto_prem" form={form} service={service} type="number" label="Custo médio bruto" disabled />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="produto_empresa.custo_medio_liquido_prem" form={form} service={service} type="number" label="Custo médio líquido" disabled />
                    </GridForm>
                </TabPanel>

                <TabPanel header="E-commerce" leftIcon="pi pi-shopping-cart mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="descricao_resumida_prod" form={form} service={service} type="text" clearString label="Descrição resumida" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="meta_descricao_prod" form={form} service={service} type="text" clearString label="Meta descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="meta_key_prod" form={form} service={service} type="text" clearString label="Meta key" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="meta_titulo_prod" form={form} service={service} type="text" clearString label="Meta título" />
                    </GridForm>
                </TabPanel>
                <TabPanel header="Fotos" leftIcon="pi pi-camera mr-2">
                    <div className='flex flex-row flex-wrap justify-content-start gap-2'>

                        {arquivo.fields.map((item, index) => {

                            if (item.cod_tiarq_arq !== 2) return null // Somente thumbnails

                            const imgUrl = `${auth.getData().bucketPath}/produto/${item.nome_armazenado_arq}`
                            const imgUrlOriginal = `${auth.getData().bucketPath}/produto/${getImgUrlOriginal(item.id_grupo_arq)}`

                            return (

                                <div id='box' key={item.id} className='flex flex-column border-1 border-round-lg justify-content-between align-items-center w-7rem h-9rem'>

                                    <div className='flex flex-column justify-content-center h-full'>
                                        <Image
                                            id={`imgProduto`}
                                            imageClassName="flex border-round-lg"
                                            src={imgUrl}
                                            zoomSrc={imgUrlOriginal}
                                            alt="Image do produto"
                                            preview
                                        />
                                    </div>

                                    {/* RODAPÉ DA IMAGEM */}

                                    <div id='rodape'
                                        className='flex flex-row justify-content-between align-items-center w-6rem'
                                    >

                                        <span className="text-xs ml-0 max-h-1rem overflow-hidden text-ellipsis ml-2">{item.nome_original_arq.split('.')[0]}</span>

                                        <Button
                                            id="btnRmImage"
                                            className="flex"
                                            icon="pi pi-trash"
                                            size="small"
                                            severity="warning"
                                            text
                                            onClick={(e) => {
                                                e.preventDefault()

                                                const nome = item.nome_original_arq + ' ' + item.nome_armazenado_arq || null

                                                const fnRemover = async () => {
                                                    const removeds = form.getValues(`arquivoRemoved`) || []
                                                    if (item?.codigo_arq) {

                                                        const fullImage = arquivo.fields.find((e) => e.id_grupo_arq === item.id_grupo_arq && e.cod_tiarq_arq === 1)

                                                        removeds.push({ codigo_arq: item.codigo_arq })
                                                        removeds.push({ codigo_arq: fullImage.codigo_arq })

                                                        form.setValue('arquivoRemoved', removeds)
                                                    }
                                                    arquivo.remove(index, { shouldFocus: false })

                                                    // SALVA E RECARREGA O FORMULÁRIO

                                                    const dataCopy = service.prepareToSave({ data: structuredClone(form.getValues()) })

                                                    service.save(id, dataCopy).then(async (response) => {
                                                        await reloadForm({ dataId: response.data.codigo_prod || id, navigate })
                                                    })

                                                }

                                                if (nome) {
                                                    confirmDialog({ message: 'Confirma remover? ' + nome, icon: 'pi pi-question-circle', accept: fnRemover })
                                                } else {
                                                    fnRemover()
                                                }
                                            }}

                                        />

                                    </div>
                                </div>

                            )
                        })}


                    </div>
                    <input key={inputKey} id="upload-input" type="file" accept="image/*" style={{ display: 'none' }} ref={inputImageRef} onChange={handleImageChange} />
                    <GridForm>
                        <div className='md:col-6 lg:col-4 xl:col-1'>

                            <Button
                                id='btnAddFoto'
                                icon="pi pi-plus" outlined rounded
                                onClick={e => {
                                    e.preventDefault()
                                    inputImageRef.current.value = ''
                                    inputImageRef.current.click()
                                }}
                            />
                        </div>
                    </GridForm>
                </TabPanel>

                <TabPanel header="Fiscal" leftIcon="pi pi-eye mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_anp_prod" form={form} service={service} type="text" inputMode="numeric" clearString label="Código ANP" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="num_di_prod" form={form} service={service} type="text" inputMode="numeric" clearString label="Número de decl. de importação (DI)" />
                    </GridForm>
                </TabPanel>

                <TabPanel header="Detalhes" leftIcon="pi pi-wrench mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="obs_prod" form={form} service={service} type="textarea" clearString label="Observação" rows={4} />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="obs_nota_prod" form={form} service={service} type="text" clearString label="Observação NF" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_terceiro_prod" form={form} service={service} type="text" clearString label="Código de terceiros" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="uid_prod" form={form} service={service} type="text" clearString label="UID" disabled />
                    </GridForm>
                </TabPanel>


                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0} >
                    <GridForm>

                        <OutputSpanForm field="usu_ins_prod" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={form.getValues('usu_ins_prod') + ' - ' + registro?.meta?.nome_razao_usu_ins} label="Inserido por" />
                        <OutputSpanForm field="cod_emp_prod" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={form.getValues('cod_emp_prod') + ' - ' + registro?.meta?.nome_razao_emp} label="Na empresa" />
                        <OutputSpanForm field="dh_ins_prod" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_ins_prod'))} label="Inserido em" />
                        <OutputSpanForm field="usu_atua_prod" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={form.getValues('usu_atua_prod') + ' - ' + registro?.meta?.nome_razao_usu_atu} label="Atualizado por" />
                        <OutputSpanForm field="dh_atua_prod" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_atua_prod'))} label="Atualizado em" />

                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
